import { Controller, useForm } from 'react-hook-form';
import { useHistory } from 'react-router-dom';
import { yupResolver } from '@hookform/resolvers/yup';
import { Button, Link, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import clsx from 'clsx';
import {
  Auth_EmailVerificationInput,
  EmailVerificationType,
  useAuth_EmailVerificationMutation,
} from 'queries';
import * as yup from 'yup';

import FormTextField from 'common/form-text-field';
import { NotificationSeverity, showAlert } from 'utils/notification-manager';

const useStyles = makeStyles(() => ({
  root: {
    marginTop: '25px',
    paddingLeft: '15vw',
    paddingRight: '15vw',
  },
  input: {
    display: 'flex',
    margin: 'auto',
  },
  inputError: {
    backgroundColor: '#FFF1F1',
  },
}));

const schema = yup.object().shape({
  email: yup.string().required().email(),
});

type Props = {
  // eslint-disable-next-line @typescript-eslint/ban-types
  updateParent: Function;
  verificationType: EmailVerificationType;
  validationEmail?: string;
  returnPath: string;
};

const VerifyEmail = ({ updateParent, verificationType, validationEmail, returnPath }: Props) => {
  const classes = useStyles();
  const history = useHistory();
  const {
    handleSubmit,
    formState: { errors, isSubmitting },
    control,
    watch,
  } = useForm<Auth_EmailVerificationInput>({
    // @ts-expect-error - RHF V7 limitation #7895
    resolver: yupResolver(schema),
  });
  const email = watch('email');

  const [emailVerificationMutation, { loading: emailVerificationMutationExecuting }] =
    useAuth_EmailVerificationMutation({
      onCompleted: () => updateParent(email || 'your inbox'),
      onError: (e) =>
        showAlert({
          message: 'Error verifying email: ' + e.message,
          severity: NotificationSeverity.ERROR,
        }),
    });

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const onSubmit = async (formData: any) => {
    if (
      validationEmail &&
      validationEmail.toLocaleLowerCase() !== formData.email.toLocaleLowerCase()
    ) {
      showAlert({
        message: 'Incorrect email provided',
        severity: NotificationSeverity.ERROR,
      });
      return;
    }

    await emailVerificationMutation({
      variables: {
        input: {
          email: formData.email,
          verificationType,
        },
      },
    });
  };

  return (
    <form className={classes.root} onSubmit={handleSubmit(onSubmit)}>
      <div>
        <Controller
          name="email"
          control={control}
          render={({ field: { ref, name, onBlur, onChange, value } }) => (
            <FormTextField
              name={name}
              defaultValue={value}
              onChange={onChange}
              onBlur={onBlur}
              ref={ref}
              errorMessage={errors.email?.message}
              label="Email"
              placeholder="example@gmail.com"
              className={clsx(classes.input, errors.email && classes.inputError)}
            />
          )}
        />
      </div>
      <div style={{ textAlign: 'center', marginTop: '50px', marginBottom: '50px' }}>
        <Button
          type="submit"
          variant="contained"
          color="secondary"
          disabled={isSubmitting || emailVerificationMutationExecuting}
        >
          Send Verification Link
        </Button>
        <Typography style={{ marginTop: '25px', textDecoration: 'underline', cursor: 'pointer' }}>
          <Link onClick={() => history.push(returnPath)}>Go back to the previous page</Link>
        </Typography>
      </div>
    </form>
  );
};

export default VerifyEmail;
